// WORK STATUS
export const GET_WORK_STATUSES = '/work_status/query';
export const GET_WORK_STATUS = '/work_status/';
export const POST_WORK_STATUS = '/work_status/';
export const PUT_WORK_STATUS = '/work_status/';
export const DELETE_WORK_STATUS = '/work_status/';
export const CHECK_WORK_STATUS_EXISTS = '/work_status/query';
